import { type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './style.module.scss';

interface MetricCardProperties {
  readonly className?: string;
  readonly children: ReactNode;
}

const Card = ({ children, className }: MetricCardProperties): ReactNode => (
  <div className={clsx(styles.container, className)}>{children}</div>
);

export default Card;
